module.exports = __webpack_public_path__ + "static/starry-night-raw-82eaf5c52f377fe730ae41688f09e619.png";